import React, {useEffect, useState,useMemo} from 'react';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import {
  View,
  Text,
  StyleSheet,
  Dimensions,
  Platform,
  Pressable,
} from 'react-native';
import Preview from '../payload-components/Preview';
import RecipientsView from './RecipientsView';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import Tooltip from '@mui/material/Tooltip';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

 

  const DemoPaper = styled(Paper)(({ theme }) => ({
    width: 350,
    height:'auto',
    padding: theme.spacing(2),
    ...theme.typography.body2,
    textAlign: 'center',
  }));

  
interface IblueData {
    message_type: string;
    message: [];
    recipients: string;
    workflow: string;
  }

const  RecipientsResponses=(props:any)=>{
  const[codebluedata, setCodebluedata]=useState<any[]>([]);
  const [submit, setSubmit]= useState(props.isSubmit);
  const [responseData, setResponseData]=useState<any>({});
  var mydata:any=[];
 
   
  useEffect(()=>{
 
      if(codebluedata){
       
        updatePayload();
      }
     
      //console.log("responseData: ",responseData);
     
     
  },[submit,props.isSubmit,localStorage]);

   
  const updatePayload=()=>{
    Object.keys(localStorage).forEach(function(key){
      // console.log( "keys:",key,localStorage.getItem(key));
        
         if(key.indexOf("token")>-1 || key.indexOf("workflow")>-1){
         }
         else{
          var ndata:any = localStorage.getItem(key);
          mydata.push(JSON.parse(ndata));
         }
      });
      
      setCodebluedata(mydata);


      var myuserdata:any=[];
     Object.keys(localStorage).forEach(function(key){
       //console.log( "keys:",key,localStorage.getItem(key));
        
        if(key.indexOf("workflow")>-1){
          var ndata:any = localStorage.getItem(key);
          
          myuserdata.push(JSON.parse(ndata));
         // add(JSON.parse(ndata));
         
        }
      });
      //console.log(myuserdata);

      setResponseData(myuserdata);
  };


  window.addEventListener('storage', () => {
    console.log("Change to local storage!");
    var nuser:any=[];
    Object.keys(localStorage).forEach(function(key){
        //console.log( "keys:",key,localStorage.getItem(key));
        
        if(key.indexOf("workflow")>-1){
          var ndata:any = localStorage.getItem(key);
          nuser.push(JSON.parse(ndata));
       
          
          setResponseData(nuser);
         
        }
      });
     

    
    // ...

    
})
  
const removeItem=(data:any)=>{
    console.log(data);
    var ntemp =data.message_type.replace(/\s+/g, '');
    var newType = ntemp.toLowerCase();
    var nuser:any=[];
    Object.keys(localStorage).forEach(function(key){
        if(key.indexOf(newType)>-1){
          var ndata:any = localStorage.getItem(key);
          var nlocal = JSON.parse(ndata);
           if(nlocal.workflow === data.workflow){
               localStorage.removeItem(key);
           }
         
        }
      });

      Object.keys(localStorage).forEach(function(key){
        if(key.indexOf('workflow')>-1){
          var ndata:any = localStorage.getItem(key);
          var nlocal = JSON.parse(ndata);
           if(nlocal.workflow === data.workflow){
               localStorage.removeItem(key);
           }
         
        }
      });
      updatePayload();
};

const lookUser=(e:any)=>{
   //console.log("lookUser..",e);
   props.setUser(e);
  props.setValueTabs(2);
};

  /* 
          // @ts-ignore */
  const Demo = ({ results }) => (
<View style={{justifyContent:'space-around', flexDirection:'column'}}>
    {results.length > 0 && (
      Array.from({ length: Math.ceil(results.length / 3) }, (_, i) => (
        
        <Stack direction="row" spacing={2} key={`st`+Math.random()}>
        {
           /* 
          // @ts-ignore */
          results.slice(i * 3, (i + 1) * 3).map((movie) => (
            <DemoPaper key={`dm`+Math.random()} square={false} style={{marginTop:20}}>
              <View style={{flexDirection:'row', marginRight:-10}}>
              <Preview data={movie.message} messageType={movie.message_type} label={"View SMS"} />
                <Pressable style={{marginTop:-13}} onPress={()=>removeItem(movie)}>
                <HighlightOffIcon  color='error' style={{ fontSize: 30 }}/>
                </Pressable>
             
              </View>
              
              <View  key={"view"+i} style={{flexDirection:'column',paddingBottom:10}}>
                <Text  key={movie.message_type} style={{fontSize:12}}>{movie.message_type}</Text>
                <Text   key={movie.workflow} style={{fontSize:12, paddingBottom:20}}>{movie.workflow}</Text>
                <View style={{flexDirection:'column', justifyContent:'space-evenly'}}>
                  {
                     
                     /* 
          // @ts-ignore */
                 responseData && responseData.map((item,i)=>(
                   
                      <View key={"rr"+Math.random()} style={{flexDirection:'row', justifyContent:'space-between', paddingTop:2,alignItems:'center',}}>
                         <Tooltip title="look-up recipient" style={{display:item.workflow ==="" ? 'none':'flex'}}>
                           <span>
                            <Pressable  onPress={() =>lookUser(item.recipients)} style={{flexDirection:'row',alignItems:'center', display:item.workflow ==="" ? 'none':'flex'}} >
                               {item.workflow ===movie.workflow ? <AccountCircleIcon  style={{color:Math.floor(Math.random()*16777215).toString(16)}}/>:<></>}
                                <Text style={{fontSize:13,}} key={item.recipients+i}>{item.workflow ===movie.workflow ? item.recipients:""}</Text>
                            </Pressable>
                            </span>
                         </Tooltip>
                     
                      <Text style={{color:item.choices === "Accept" ? "green":"red", fontWeight:'bold'}} key={item.choices+i}>{item.workflow ===movie.workflow ? item.choices :"" }</Text>
                      </View>
                  
                  ))
                  
                  }
                  </View>
                </View>
              </DemoPaper>
            
            ))
        }
        
        </Stack>
      ))
    )}
    </View>
  )
  
  
 
 
  
    return(
      <View style={{flexDirection:'row', justifyContent:'center'}}>
               
       <Demo results={codebluedata}/>
      </View>
    );
};


const style = StyleSheet.create({
  full: {
    flex: 1,
    // padding: 20,
  },
  gridRow: {
    flex: 1,
    flexDirection: 'row',
    width: '100%',
    paddingVertical: 10,
  },
  gridVideoContainerInner: {
    // borderColor: '#fff',
    // borderWidth:2,
    // width: '100%',
    borderRadius: 15,
    flex: 1,
    overflow: 'hidden',
    // margin: 1,
    marginHorizontal: 10,
  },

});
export default RecipientsResponses